import { render, staticRenderFns } from "./ProductAddedToListModal.vue?vue&type=template&id=b2fbdbd4"
import script from "./ProductAddedToListModal.vue?vue&type=script&lang=js"
export * from "./ProductAddedToListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports